export default {
  // i18n
  langs: ['en', 'de', 'nl'],
  defaultLangKey: 'en',
}



// WEBPACK FOOTER //
// ./config/SiteConfig.js